module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/摄像头.e6b5683a.png";